import { useSelector } from "react-redux";
import { selectCurrentLogbook } from "../../store/features/logbooks.slice";
import LogbookFolder from "../common/logbook-folder";

export default function CompanyLogbookFolder() {
  const logbook = useSelector(selectCurrentLogbook);

  return (
    <LogbookFolder
      isCompanyUser
      logbookId={logbook.id}
      folders={logbook.folders}
      documents={logbook.documents}
      description={logbook.description}
    />
  );
}
